// extracted by mini-css-extract-plugin
export var dropdownIcon = "_kr-6";
export var imgContainer = "_kr-3";
export var menuIcon = "_kr-5";
export var pillWrapper = "_kr-2";
export var pillsContainer = "_kr-1";
export var subscriptionCard = "_kr-0";
export var subscriptionLogo = "_kr-4";